import { Country, Checkout } from '@afterpaytouch/portal-api/types'
import { BiometricsCheckTrigger, InitialData, OtpLoginRouteAndTriggerResult, ConvergenceRollout } from '../../../model'
import { getValidUserEmailAndMobile } from '../../login-identifier'
import { determineRedirectCountry } from '../countryRedirection'
import { createBiometricEligibilityPayload } from '../biometricEligibility'
import { SequentialLookupRequest } from './sequentialLookupOrchestrator'

export interface LookupDataPreparationRequest {
  checkout: Checkout
  country: Country
  validInitialData: InitialData
  browserCapabilities: {
    canSupportBiometric: boolean
    isAuthenticatorAvailable: boolean
  }
  usernameFromCookie: string | null
  biometricsEligibleAndRegisteredCheckTrigger: BiometricsCheckTrigger
  otpLoginRouteAndTrigger: OtpLoginRouteAndTriggerResult
  rollout: ConvergenceRollout
}

export const prepareLookupData = (request: LookupDataPreparationRequest): Omit<SequentialLookupRequest, 'checkout'> => {
  const {
    checkout,
    country,
    validInitialData,
    browserCapabilities,
    usernameFromCookie,
    biometricsEligibleAndRegisteredCheckTrigger,
    otpLoginRouteAndTrigger,
    rollout,
  } = request

  const redirectCountry = determineRedirectCountry({
    shippingCountryCode: checkout.shippingAddress?.countryCode,
    billingCountryCode: checkout.billingAddress?.countryCode,
    merchant: checkout.merchant,
    currentCountry: country,
  })

  const crossRegionUserSignInEmail = checkout.crossRegionUserSignIn?.consumerEmail
  const { email, mobileNumber } = getValidUserEmailAndMobile({
    crossRegionUserSignInEmail,
    checkoutEmail: checkout.consumer?.email,
    checkoutMobile: checkout.consumer?.phoneNumber,
    usernameFromCookie,
  })

  const isBiometricEligiblePayload = createBiometricEligibilityPayload({
    browserCanSupportBiometric: browserCapabilities.canSupportBiometric,
    isAuthenticatorAvailable: browserCapabilities.isAuthenticatorAvailable,
    initialData: validInitialData,
  })

  return {
    email,
    mobileNumber,
    country,
    redirectCountry,
    biometricCheckTrigger: biometricsEligibleAndRegisteredCheckTrigger,
    isBiometricEligiblePayload,
    otpLoginRouteAndTrigger,
    rollout,
  }
}
